function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M31,16H17v14h14V16z M29,28H19V18h10V28z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m52 16h-16c-0.553 0-1 0.447-1 1s0.447 1 1 1h16c0.553 0 1-0.447 1-1s-0.447-1-1-1z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m52 22h-16c-0.553 0-1 0.447-1 1s0.447 1 1 1h16c0.553 0 1-0.447 1-1s-0.447-1-1-1z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m52 28h-16c-0.553 0-1 0.447-1 1s0.447 1 1 1h16c0.553 0 1-0.447 1-1s-0.447-1-1-1z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m52 34h-33c-0.553 0-1 0.447-1 1s0.447 1 1 1h33c0.553 0 1-0.447 1-1s-0.447-1-1-1z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "m34 40h-15c-0.553 0-1 0.447-1 1s0.447 1 1 1h15c0.553 0 1-0.447 1-1s-0.447-1-1-1z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "m34 46h-15c-0.553 0-1 0.447-1 1s0.447 1 1 1h15c0.553 0 1-0.447 1-1s-0.447-1-1-1z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "m34 52h-15c-0.553 0-1 0.447-1 1s0.447 1 1 1h15c0.553 0 1-0.447 1-1s-0.447-1-1-1z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39,54h14V40H39V54z M41,42h10v10H41V42z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M59,13c0-0.017-0.009-0.031-0.01-0.048V0H11v30H1v24c0,3.309,2.691,6,6,6h46c3.303,0,5.99-2.688,5.99-5.99V13.048   C58.991,13.031,59,13.017,59,13z M56.99,2v10H13V2H56.99z M3,54V32h8v22c0,2.206-1.794,4-4,4S3,56.206,3,54z M53,58H11.469   c0.016-0.018,0.027-0.039,0.042-0.057c0.204-0.233,0.39-0.482,0.556-0.745c0.027-0.042,0.052-0.084,0.078-0.128   c0.162-0.27,0.305-0.552,0.423-0.848c0.016-0.041,0.03-0.082,0.045-0.123c0.115-0.306,0.209-0.622,0.273-0.949   c0.006-0.03,0.008-0.061,0.014-0.09C12.962,54.716,13,54.362,13,54V30V14h43.99v40.01C56.99,56.21,55.2,58,53,58z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M47,4H23v6h24V4z M45,8H25V6h20V8z"
});

var SvgMedia = function SvgMedia(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    enableBackground: "new 0 0 60 60",
    viewBox: "0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMedia, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/media.7a110b2e.svg";
export { ForwardRef as ReactComponent };